import React, { useEffect, useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
    useOnClose,
    updatePopupAction,
    setLayerArtifactsAction,
    useDynamicLayerReducerDispatch
} from 'js/components/common/PopupManager';

import { ShallowPopup } from './ShallowPopup';

// it receives props from its wrapper component, which in turn receives props from
// PopupManager/Layer/PopupFactory chain. Most props are from popups store.
export const ManagedPopup = (props) => {
    const commonDispatch = useDispatch();
    const dispatch = useDynamicLayerReducerDispatch();
    const defaultOnClose = useOnClose();
    const { id, onClose = defaultOnClose, onOverlayClick = onClose, layerClassNames } = props;

    // apply layer styles without flickering
    useLayoutEffect(() => {
        if (id && layerClassNames) {
            commonDispatch(updatePopupAction({ id, layerClassNames }));
        }
    }, [id, commonDispatch, layerClassNames]);

    useEffect(() => {
        dispatch(setLayerArtifactsAction({ onOverlayClick }));
    }, [dispatch, onOverlayClick]);

    return <ShallowPopup {...props} onClose={onClose} />;
};
